import $ from "jquery"
import {
  getOptions,
  setOptions,
  addFunction,
  updateDimentionEvent,
} from "./variables"
import { mfpf, mfpb, mfpclick, labelclick } from "./mfpTootls"
import _ from "../utils/lodash"

let mfp_phase_input_step = null
let mfp_phase_input_currentId = null

export function startupMailform(w, d) {
  let valueList = []
  const { obj, conservationKey, mfp_tr_color, mfp_tr_color_cover } =
    getOptions()

  if (!obj) return false
  // phase Input startup
  if (d.querySelectorAll("[id^=mfp_phase_]").length > 0) {
    if (location.hash && location.hash.indexOf("phase_") > -1)
      mfp_phase_input_currentId = location.hash.replace(/#phase_/g, "")
    else mfp_phase_input_currentId = 1
    d.getElementById("mfp_phase_" + mfp_phase_input_currentId).style.display =
      "block"
    if (d.getElementById("mfp_phase_" + mfp_phase_input_currentId + "_label"))
      d.getElementById(
        "mfp_phase_" + mfp_phase_input_currentId + "_label"
      ).className = "mfp_phase_current"

    var pi = 1
    while (d.getElementById("mfp_phase_" + pi)) {
      mfp_phase_input_step = pi
      pi++
    }
  }
  //

  const timer = _.find(obj, (e) => e.name === "input_time")
  if (timer) {
    setOptions({ timer })
  }

  const cookie = Cookies.get("mailform")
  if (cookie && cookie.indexOf(conservationKey) > -1) {
    valueList = cookie.split(conservationKey)
    valueList = valueList[1].split("&")

    let checked_count = Object.values(obj).reduce((prev, current) => {
      return current.type != "hidden" &&
        current.type != "file" &&
        current.type != "button" &&
        current.type != "submit" &&
        current.type != "image"
        ? prev + 1
        : prev
    }, 0)

    const getValue = () => {
      return valueList.length ? valueList.shift() : null
    }

    if (valueList.length === checked_count) {
      Object.values(obj).forEach((elem) => {
        if (elem.type == "checkbox" || elem.type == "radio") {
          if (getValue() == 1) {
            elem.checked = true
          } else {
            elem.checked = false
          }
        } else if (elem.type == "text" || elem.type == "textarea") {
          const v = getValue()
          elem.value = unescape(v)
          if (elem.name === "email") {
            setOptions({ mfp_emailaddress: v, mail_address: v })
          }
        } else if (elem.type == "select-multiple") {
          getValue()
            .split(",")
            .map((value) => {
              if (value != "") {
                elem.options[value].selected = true
              }
            })
        } else if (elem.type == "select-one") {
          const value = getValue()
          if (elem.options[value]) elem.options[value].selected = true
        }
      })
    }
  }

  addFunction(() => {
    const { timer } = getOptions()
    timer.value = parseInt(timer.value, 10) + 1
  })
  addFunction(() => {
    updateDimentionEvent()
  })

  if (d.getElementsByTagName("BODY").length == 0) d.write("<body>")
  const element = document.createElement("div")
  element.id = "confirm-wrapper"
  var objBody = document.getElementsByTagName("body").item(0)
  objBody.appendChild(element)

  setOptions({
    confirmWrap: element,
  })

  $("input.mfp, textarea.mfp").on("focus", function () {
    mfpf(this)
  })

  $("input.mfp, textarea.mfp, select.mfp").on("blur change", function () {
    mfpb(this)
  })

  $("input.mfp").click(function () {
    mfpclick(this)
  })

  $("label.mfp").click(function () {
    labelclick(this)
  })
}
